export default class AbortSubmissionError extends Error {
  constructor(message?: string) {
    super(message);
    Object.defineProperty(this, 'name', { value: 'AbortSubmissionError' });
  }
}
